module.exports = __webpack_public_path__ + "static/media/29ADMSPC4.d40e3e26.jpg";